<template>
  <div>
    <el-table
      :data="users.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Channels" width="100%">
        <template slot-scope="props">
          <div v-for="(value, key) in props.row.channels" :key="new Date().getTime() + key">
            <el-tooltip v-if="value" :content="value.channelName" placement="right">
              <div :class="`pointer social-icon`" :style="channelBgImg(key, value)"
                   @click="openPlatform(key, value)"></div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="First name" prop="first_name" sortable="custom"></el-table-column>
      <el-table-column label="Last name" prop="surname" sortable="custom"></el-table-column>
      <el-table-column label="E-mail" prop="email" sortable="custom"></el-table-column>
      <el-table-column label="Country" prop="country_of_residence" sortable="custom"></el-table-column>
      <el-table-column label="User level" prop="user_level" width="100">
        <template slot-scope="props">
          <el-tag class="capitalize" :type="tagType(props.row.user_level)">
            {{ props.row.user_level | underscore_to_space }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User level" prop="user_tier" sortable="custom" width="110">
        <template slot-scope="props">
          <el-tag :type="tierType(props.row.user_tier)">
            {{ tierName(props.row.user_tier) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User tier" prop="creator_tier" sortable="custom" width="100"></el-table-column>
      <el-table-column label="Channel category" prop="ytCategory" sortable="custom" align="center">
        <template slot-scope="props">
          {{ props.row.yt_category ? props.row.yt_category.name : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Subscribers" prop="subscribers" sortable="custom">
        <template slot-scope="props">
          {{ props.row.subscribers ? commaNum(props.row.subscribers) : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="User Wallet" prop="wallet" sortable="custom">
        <template slot-scope="props">
          {{ props.row.wallet ? '$'+props.row.wallet.toFixed(2) : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Monetization" prop="youtube_monetize" sortable="custom">
        <template slot-scope="props">
          {{
            props.row.youtube_monetize_updated
              ? (props.row.youtube_monetize ? "Yes" : "No") + " (" + moment(props.row.youtube_monetize_updated).format('DD MMMM YYYY')+")"
              : "/"
          }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="220" align="center" v-if="level3">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button type="warning" circle size="small" icon="el-icon-edit" @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <el-button type="danger" circle size="small" icon="el-icon-close" @click="deleteU(props.row.id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="More Info" placement="top">
            <el-button type="info" icon="el-icon-document" @click="openAdditionalModalInfo(props.row)" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="Social Networks" placement="top" :disabled="disableSNTooltip">
            <SocialNetworks :channels="props.row.channels" @tierModal="(v) => disableSNTooltip = v" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="float-right" background @size-change="sizeChange" @current-change="currentChange"
      :current-page.sync="users.current_page" :page-sizes="[10, 25, 50, 100]" :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper" :total="users.total"
    ></el-pagination>

    <el-dialog title="Creator additional info" :visible.sync="creatorAdditionModal">
      <el-table :data="[additionalData]" v-loading="additionalInfoLoader">
        <el-table-column label="Avrage Views" align="center">
          <template slot-scope="props"> {{ commaNum(props.row.avgViews) }} </template>
        </el-table-column>
        <el-table-column label="Seconds used > 15" align="center">
          <template slot-scope="props"> {{ commaNum(props.row.sumOfUninterruptedSeconds) }} </template>
        </el-table-column>
        <el-table-column label="Challenges" align="center">
          <template slot-scope="props"> {{ commaNum(props.row.challenges) }} </template>
        </el-table-column>
        <el-table-column label="Points" align="center">
          <template slot-scope="props"> {{ commaNum(props.row.experience) }} </template>
        </el-table-column>
        <el-table-column label="Level" align="center">
          <template slot-scope="props">
            {{ props.row.experienceProgress ? commaNum(props.row.experienceProgress.level) : '' }}
          </template>
        </el-table-column>
        <el-table-column label="Music Preferences" align="center">
          <template slot-scope="props">
            <el-popover trigger="hover" v-if="props.row.musicPreferences">
              <el-tag v-for="g in props.row.musicPreferences" :key="g.id" type="info" class="genre">{{ g.name }}</el-tag>
              <span slot="reference" class="hasGenres">{{ props.row.musicPreferences.length }}</span>
            </el-popover>
            <span v-else slot="reference">0</span>
          </template>
        </el-table-column>
        <el-table-column label="Genres Used" align="center">
          <template slot-scope="props">
            <el-popover trigger="hover" v-if="props.row.genresUsed">
              <el-tag v-for="(g, i) in props.row.genresUsed" :key="i" type="info" class="genre">{{ g }}</el-tag>
              <span slot="reference" class="hasGenres">{{ props.row.genresUsed.length }}</span>
            </el-popover>
            <span v-else slot="reference">0</span>
          </template>
        </el-table-column>
        <el-table-column label="Videos Made" align="center">
          <template slot-scope="props"> {{ commaNum(props.row.numOfVideos) }} </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import SocialNetworks from "@/modules/admin/user/components/SocialNetworks";
import { mapState, mapActions, mapMutations } from 'vuex'
import { pick as _pick } from 'lodash'
import store from "../../../../plugins/vuex";
import moment from "moment";

export default {
  data() {
    return {
      moment: moment,
      dialogTier: false,
      user_tier: '',
      user_channel: [],
      user_status: null,
      creatorAdditionModal: false,
      disableSNTooltip: false
    }
  },

  components: {
    SocialNetworks
  },

  computed: {
    ...mapState('mcnUsers', [
      'users',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'loading',
      'additionalInfoLoader',
      'additionalData'
    ]),
    ...mapState('user', ['user']),
    level3: function() {
      if (store.state.auth.user.permission === 3) return true
      else {
        return false
      }
    }
  },

  methods: {
    ...mapActions('mcnUsers', ['readMcnUsers', 'getAdditionalInfo']),
    ...mapActions('user', [
      'delete',
      'update',
      'getCompanyAdminArtist'
    ]),
    ...mapMutations('mcnUsers', [
      'setMcnPage',
      'setPageSize',
      'setOrdering',
      'setLoading'
    ]),
    ...mapMutations('user', ['setShowWallet', 'setSelectedUser', 'setDialog', 'setTierDialog']),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readMcnUsers()
    },
    currentChange(page) {
      this.setMcnPage(page)
      this.readMcnUsers()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readMcnUsers()
    },
    tagType(level) {
      switch (level) {
        case 'guest':
          return 'info'
        case 'user':
          return 'success'
        case 'company_admin':
          return ''
        case 'sysadmin':
          return 'danger'
        default:
          return 'warning'
      }
    },

    openAdditionalModalInfo({ id }) {
      this.creatorAdditionModal = true
      this.getAdditionalInfo(id)
    },
    channelBgImg(platform, data) {
      let img = require(`@/assets/icons/${platform}.svg`)
      return `
        mask-image:url('${img}');
        -webkit-mask:url('${img}');
        background-repeat: no-repeat;
        background-position-x: right;
        background-origin: content-box;
        background-color: ${this.socialIconColor(data)};
      `
    },

    socialIconColor(data) {
      let color = 'black'
      if (data.approved === 1) color = '#67C23A'
      else if (data.approved === 2) color = '#d40c41'
      else if (data.approved === 3) color = '#ffa500'
      return color
    },

    openPlatform(platform, data) {
      if (platform === 'youtube') {
        window.open('https://youtube.com/channel/' + data.channelId)
      }
      else if (platform === 'instagram') {
        if (data.channelId.startsWith('https://')){
          window.open(data.channelId);
        } else {
          window.open('https://instagram.com/' + data.channelId);
        }
      }
      else if (platform === 'tiktok') {
        if (data.channelId.startsWith('https://')){
          window.open(data.channelId);
        } else {
          window.open('https://tiktok.com/' + data.channelId);
        }
      }
    },

    openEdit(user) {
      user = _pick(user, [
        'surname', 'user_level', 'user_tier', 'wallet', 'label', 'id', 'first_name', 'email',
        'country_of_residence', 'artist', 'company_admin', 'image_url', 'featured',
        'spotlight', 'leaderboard', 'name', 'phone', 'birthday', 'address', 'biography', 'channels'
      ])
      this.setShowWallet(true)
      this.setSelectedUser(JSON.parse(JSON.stringify(user)))
      this.setDialog(true)
    },

    deleteU(id) {
      this.$confirm(
        'You will permanently delete this user. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id).then(() => {
            this.readMcnUsers()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.readMcnUsers()
  }
}
</script>

<style scoped>
.social-icon {
  width: 25px;
  height: 25px;
  margin-bottom: 3px;
}

.hasGenres {
  cursor: pointer;
  width: 50px;
  margin: 0 auto;
  display: inline-block;
}

.genre {
  margin-right: 10px;
}
</style>
